import script from "./pagePerItems.vue?vue&type=script&setup=true&lang=js"
export * from "./pagePerItems.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__